import remote from 'AppReact/stateManager/remote'

export default {
  'ResidentOrderLink.WOCreation': async ({ unitId, propertyId, clipboardItem = ClipboardItem }, _, internalStateSetter) => {
    const text = new clipboardItem({
      "text/plain": remote.get(`/api/orders?link=true&property_id=${propertyId}&unit_id=${unitId ?? ''}`)
        .then(r => r.data.url)
        .then(text => new Blob([text], { type: "text/plain" }))
    })

    navigator.clipboard.write([text]).then(() => {
      internalStateSetter({ linkCopied: true });
      setTimeout(() => {
        internalStateSetter({ linkCopied: false })
      }, 3000)
    })
  }
}